import type {FactoryOpts} from 'imask';

export const moneyMask = (
  forceDecimals = true,
  currencySymbol = '$'
): FactoryOpts => ({
  lazy: false,
  mask: `${currencySymbol}num`,
  blocks: {
    num: {
      mask: Number,
      scale: 2,
      thousandsSeparator: ',',
      padFractionalZeros: forceDecimals,
      normalizeZeros: true,
      radix: '.',
      mapToRadix: ['.'],
    },
  },
});

export const numberOfSecurities = (
  amount: number,
  price_per_security: number
) => {
  return Math.ceil(amount / price_per_security);
};
